<template>
    <div class="wrapper">
        <h1>404</h1>
        <h2>Page Not Found</h2>
    </div>
</template>

<script>
    export default {}
</script>

<style lang="stylus" scoped>
    @import '../../assets/styles/variables/color'
    .wrapper
        align-items center
        background color_background
        display flex
        justify-content center
        min-height 100vh
        flex-direction column
        h1
            color color_main !important
            font-size 5em
</style>


// WEBPACK FOOTER //
// 404.vue?c272ba20